import TourCalculatorLayout from "./tour/tourCalculatorLayout";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box'
import { useCallback, useEffect, useState } from "react";
import { useTheme } from "@mui/material";
import SitesAndCalculatorLayout from "./sitesAndActivites/sitesAndCalculatorLayout";
import { useNavigate, useSearchParams } from "react-router-dom";

const navOptionList = [
    {label: "Tour Calculation", value: 0},
    {label: "Sites/Activities Calculation", value: 1}
]

const CalculatorTabView = ({
    navOption
}) => {
    const [showTabView, setShowTabView] = useState(true);

    return (
        <>
            {/* Pc view */}
            <Box
                sx={{
                    backgroundImage: 
                        showTabView
                        ?
                        `linear-gradient(0deg, rgba(255, 255, 255, 0.2) 20%, rgba(255, 133, 47, 0.9)), url(/images/calculator-banner.png)`
                        :
                        'none',
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundAttachment: 'fixed',
                    width: '100%',
                    minHeight: '100vh',
                    display: {xs: 'none', lg: 'block'}
                }}
            >
                <TabView 
                    navOption={navOption}
                    showTabView={showTabView}
                    setShowTabView={setShowTabView}
                />
            </Box>

            {/* Tab and Mobile view */}
            <Box
                sx={{
                    display: {xs: 'block', lg: 'none'}
                }}
            >
                {/* Ellipse */}
                <Box
                    sx={{
                        mt: {xs: -10, sm: -20, md: -40},
                        display: showTabView ? 'flex' : 'none'
                    }}
                >
                    <img 
                        src="/images/Ellipse.png" 
                        alt="Ellipse" 
                        width='100%'
                    />
                </Box>

                <TabView 
                    navOption={navOption}
                    showTabView={showTabView}
                    setShowTabView={setShowTabView}
                />
            </Box>
        </>
    );
}

export default CalculatorTabView;

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

const TabView = ({
    navOption,
    showTabView,
    setShowTabView
}) => {
    const theme = useTheme();

    const [value, setValue] = useState(0);

    const [searchParams] = useSearchParams();
    const queryType = searchParams.get('type');

    const navigate = useNavigate();

    useEffect(() => {
        if(queryType === 'tours'){
            setValue(0);
        }
        else if(queryType === 'sites_activities'){
            setValue(1);
        }
        else{
            navigate('/calculator?type=tours');
        }
    }, [queryType]);

    const changeTabOption = useCallback((event, newValue) => {
        if(newValue === 0){
            navigate('/calculator?type=tours');
        }
        else{
            navigate('/calculator?type=sites_activities');
        }
    }, []);

    return (
        <>
            <Box 
                sx={{
                    pt: {xs: 5, lg: 5},
                    ml: {xs: 0, lg: 10}, 
                    px: {xs: '16px', lg: 10},
                    mb: {xs: 2, lg: 5},
                    display: showTabView ? 'flex' : 'none'
                }}
                width={{xs: 'fit-content', md: 'fit-content'}}
            >
                <Tabs
                    value={value}
                    onChange={changeTabOption}
                    sx={{
                        backgroundColor: {xs: '#E5E5EA', lg: theme.palette.background.default},
                        borderRadius: '8px'
                    }}
                    slotProps={{
                        indicator: {
                            style: {
                                display: 'none',
                            }
                        }
                    }}
                >
                    {
                        navOptionList.map((item, index) => {
                            return <Tab 
                                key={index}
                                label={item.label}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    color: 'black',
                                    letterSpacing: '0.36%',
                                    "&.Mui-selected": {
                                        color: 'white',
                                        backgroundColor: theme.palette.primary.light,
                                        borderRadius: '8px',
                                        fontWeight: 400,
                                        m: {xs: 0, md: 0.5},
                                        px: 1
                                    }
                                }}
                            />
                        })
                    }
                </Tabs>
            </Box>

            <CustomTabPanel value={value} index={0}>
                <TourCalculatorLayout 
                    navOption={navOption}
                    setShowTabView={setShowTabView}
                />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
                <SitesAndCalculatorLayout 
                    navOption={navOption}
                    setShowTabView={setShowTabView}
                />
            </CustomTabPanel>
        </>
    );
}